import React, { useEffect, useState } from 'react'

export const AppUpdatedContext = React.createContext(false)

export function UpdateMonitor(props: { children: React.ReactNode }) {
  const [appUpdated, setAppUpdated] = useState(false)

  useEffect(() => {
    let etag: string | null = ''

    async function checkForUpdate() {
      try {
        const result = await fetch('/', { method: 'HEAD' })
        const newEtag = result.headers.get('etag')
        if (etag && etag != newEtag) {
          setAppUpdated(true)
        }
        etag = newEtag
      } catch (_) {
        // ignored
        // The fetch could failed for various reasons but we don't have to
        // handle it. The check for newer version could wait for the next
        // fetch.
      }
    }

    const intervalId = setInterval(checkForUpdate, 60_000)

    checkForUpdate()

    return () => clearInterval(intervalId)
  }, [])

  return (
    <AppUpdatedContext.Provider value={appUpdated}>{props.children}</AppUpdatedContext.Provider>
  )
}
